module.exports = __webpack_public_path__ + "img/type--2-spans--multiple-lang--es.5e4dd142.jpg";